<template>
  <component :is="componentName" :configurations="componentConfigurations" />
</template>

<script>
import ProductScreenshotModal from '@/components/ProductScreenshotModal'

import { mapGetters } from 'vuex'

export default {
  name: 'ModalHost',
  components: {
    ProductScreenshotModal
  },
  computed: {
    ...mapGetters({
      modalComponent: 'modalManager/component'
    }),
    componentName () {
      return this.modalComponent.name
    },
    componentConfigurations () {
      return this.modalComponent.configurations
    }
  }
}
</script>
